module.exports = __webpack_public_path__ + "img/icon_sec4_02.327f74e3.png";